import { useaxios } from "../../../utils/useaxios";
export default (user_name, user_password, user_role, user_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('user/update.php', { user_name, user_password, user_role, user_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            setrecaller(recaller + 1);
        }
        // setloading(false);
    });
}